export type SpiritPose = { x: number; y: number; size: number; rotation: number; depth: number };
const clamp = (value: number, low: number, high: number) => Math.max(low, Math.min(high, value));

// All geometry is in canvas pixels. Rendering and touch tests share this exact pose.
export function spiritPose(anchorX: number, anchorY: number, age: number, seed: number, width: number, height: number, reducedMotion = false): SpiritPose {
 const base = Math.min(width * .38, height * .43);
 if (reducedMotion) return { x: clamp(anchorX * width, base / 2, width - base / 2), y: clamp(anchorY * height, base / 2, height - base / 2), size: base, rotation: 0, depth: 1 };
 const time = Math.max(0, age);
 const approach = .72 + .64 * (.5 + .5 * Math.sin(time * 1.25 + seed));
 const entry = .58 + .42 * (1 - Math.pow(1 - clamp(time / .65, 0, 1), 3));
 const depth = approach * entry;
 const size = base * depth;
 const rotation = Math.sin(time * 1.7 + seed) * .065;
 // Rotation expands the visible square; reserve enough room for every corner.
 const margin = size * (Math.abs(Math.cos(rotation)) + Math.abs(Math.sin(rotation))) / 2 + Math.min(width, height) * .025;
 const driftX = Math.sin(time * .85 + seed) * width * .075;
 const driftY = Math.sin(time * 1.6 + seed * 1.3) * height * .035;
 return {
  x: clamp(anchorX * width + driftX, margin, width - margin),
  y: clamp(anchorY * height + driftY, margin, height - margin),
  size, rotation, depth,
 };
}

export function isSpiritHit(x: number, y: number, pose: SpiritPose): boolean {
 const dx = x - pose.x, dy = y - pose.y;
 const cosine = Math.cos(pose.rotation), sine = Math.sin(pose.rotation);
 const localX = dx * cosine + dy * sine;
 const localY = -dx * sine + dy * cosine;
 // Match the full-body sprite, with a small touch allowance around its silhouette.
 return Math.hypot(localX / (pose.size * .47), localY / (pose.size * .5)) <= 1;
}
